import React from 'react';
import Modal from './Modal';
import CustomModified from './CustomModified';

export type DialogProps = {
  open: boolean;
  onClose: () => void;
  style?: React.CSSProperties;
  title?: React.ReactNode;
  description?: React.ReactNode;
  cancelText?: React.ReactNode;
  confirmText?: React.ReactNode;
  onConfirm?: () => void;
  confirmLoading?: boolean;
  danger?: boolean;
};

export const Dialog: React.FC<DialogProps> = ({
  open,
  onClose,
  style,
  title,
  description,
  cancelText = 'Cancel',
  confirmText = 'Confirm',
  onConfirm,
  confirmLoading = false,
  danger = false,
}) => {
  return (
    <Modal
      open={open}
      onClose={onClose}
      title={title}
      dialogStyle={style}
      footer={
        <>
          <CustomModified variant="outline" onClick={onClose}>
            {cancelText}
          </CustomModified>
          <CustomModified
            onClick={onConfirm}
            loading={confirmLoading}
            className={danger ? 'bg-danger text-white' : ''}
          >
            {confirmText}
          </CustomModified>
        </>
      }
    >
      {description ? <p className="mb-0">{description}</p> : null}
    </Modal>
  );
};

export default Dialog;


